import { AutogenLayoutCbpLocationQuickInfo } from "./autogen/AutogenLayoutCbpLocationQuickInfo";

export class CbpLocationQuickInfo extends AutogenLayoutCbpLocationQuickInfo {
    sourceLocationOnDisplay() {
        this.buttonViewLocation.link = `lme/dispatch/Location?mode=update&key=${this.mainDataSource.activeRow?.getString("id", null)}`
    }
}
